import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {CoreModule} from '../../core/core.module';
import {SharedModule} from '../../shared/shared.module';
import {SearchRoutingModule} from './search-routing.module';
import { SearchPageComponent } from './components/search-page/search-page.component';
import {NgxMasonryModule} from "ngx-masonry";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SearchRoutingModule,
        CoreModule,
        SharedModule,
        NgxMasonryModule
    ],
    declarations: [SearchPageComponent]
})
export class SearchModule {
}
